import React, { useEffect, useState } from "react";
import {
  getEstadoTramitacion,
  postEstadoTramitacion,
  putEstadoTramitacion,
  //deleteEstadoTramitacion,
} from "../../componentes/http/actions/EstadoTramitacionAction";
import EditNoteIcon from "@mui/icons-material/EditNote";
import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Grid,
  Typography,
  Box,
  Button,
  Snackbar,
  Alert,
  TablePagination,
  CircularProgress,
  Chip,
  Tooltip,
} from "@mui/material";
import NuevoEstadoTramitacionModal from "../../componentes/modal/EstadoTramitacion/NuevoEstadoTramitacionModal";
import EditarEstadoTramitacionModal from "../../componentes/modal/EstadoTramitacion/EditarEstadoTramitacionModal";
import FilterComponent from "../../componentes/data/FilterComponent";

const GestorEstadoTramitacion = () => {
  const [estadoTramitacion, setEstadoTramitacion] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [estadoSeleccionado, setEstadoSeleccionado] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterHabilitado, setFilterHabilitado] = useState("todos");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    fetchEstadoTramitacion();
  }, []);

  const fetchEstadoTramitacion = () => {
    setIsLoading(true);
    getEstadoTramitacion(localStorage.getItem("token"))
      .then((response) => {
        setEstadoTramitacion(response);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
        setInitialDataLoaded(true);
      });
  };

  const filterOptions = [
    { value: "todos", label: "Todos" },
    { value: "habilitado", label: "Habilitados" },
    { value: "deshabilitado", label: "Deshabilitados" },
  ];
  const filteredEstado = estadoTramitacion
    .filter((Estado) => {
      const matchesSearch = Estado.nombre
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
      const matchesFilter =
        filterHabilitado === "todos" ||
        (filterHabilitado === "habilitado" && Estado.habilitado === true) ||
        (filterHabilitado === "deshabilitado" && Estado.habilitado === false);
      return matchesSearch && matchesFilter;
    })
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const handleSearchChange = (newSearchTerm) => {
    setSearchTerm(newSearchTerm);
    setPage(0); // Volver a la primera página al buscar
  };
  
  const handleFilterChange = (newFilter) => {
    setFilterHabilitado(newFilter);
    setPage(0); // Volver a la primera página al filtrar
  };

  //Modal de nuevo estado de tramitacion
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  //Modal de editar estado de tramitacion
  const handleOpenEditModal = (estado) => {
    setEstadoSeleccionado(estado);
    setOpenEditModal(true);
  };
  const handleCloseEditModal = () => {
    setOpenEditModal(false);
    setEstadoSeleccionado(null);
  };

  const handleNuevoEstado = async (nuevo) => {
    try {
      setIsLoading(true);
      await postEstadoTramitacion(localStorage.getItem("token"), nuevo);
      await fetchEstadoTramitacion();
      handleCloseModal();
      setSnackbar({
        open: true,
        message: "Estado de tramitación agregado con éxito",
        severity: "success",
      });
    } catch (error) {
      console.error("Error al agregar nuevo estado de tramitación:", error);
      setSnackbar({
        open: true,
        message: "Error al agregar estado de tramitación: estado ya existe o error en el servidor",
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditarEstado = async (editado) => {
    try {
      setIsLoading(true);
      await putEstadoTramitacion(localStorage.getItem("token"), editado);
      await fetchEstadoTramitacion();
      handleCloseEditModal();
      setSnackbar({
        open: true,
        message: "Estado de tramitación editado con éxito",
        severity: "success",
      });
    } catch (error) {
      console.error("Error al editar estado de tramitación:", error);
      setSnackbar({
        open: true,
        message: "Error al editar estado de tramitación: estado ya existe o error en el servidor",
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

const renderNoDataMessage = () => (
  <TableContainer component={Paper}>
    <Box p={3} sx={{ 
      width: '100%', 
    }}>
      <Typography variant="body1" color="text.secondary">
        No se encontraron estados de tramitación con los criterios de búsqueda actuales.
      </Typography>
    </Box>
  </TableContainer>
);
  return (
    <Grid container direction="column" spacing={2} sx={{paddingTop: {xs: '20px', sm: '10px'}}}>
      <Grid item>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography variant="h4">Estado de tramitación</Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpenModal}
            disabled={isLoading}
          >
            Añadir estado de tramitación
          </Button>
        </Grid>
      </Grid>
      <Grid item>
        <FilterComponent
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          filterValue={filterHabilitado}
          onFilterChange={handleFilterChange}
          filterOptions={filterOptions}
        />
      </Grid>
      <Grid item>
        {isLoading && !initialDataLoaded ? (
          <Box display="flex" justifyContent="center" p={3}>
            <CircularProgress />
          </Box>
        ) : filteredEstado.length > 0 ? (
          <>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Id</TableCell>
                <TableCell>Nombre</TableCell>
                <TableCell>Habilitado</TableCell>
                <TableCell sx={{ display: "flex", justifyContent: "center" }}>
                  Acciones{" "}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredEstado.map((estado, index) => (
                <TableRow key={index}>
                  <TableCell>{estado.id}</TableCell>
                  <TableCell>{estado.nombre}</TableCell>
                  <TableCell>
                    <Chip
                      label={estado.habilitado ? "Sí" : "No"}
                      color={estado.habilitado ? "success" : "error"}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
                      <Tooltip title="Editar estado de tramitación">
                        <Button
                          size="small"
                          color="primary"
                          sx={{ mr: 1 }}
                          onClick={() => handleOpenEditModal(estado)}
                        >
                          <EditNoteIcon />
                        </Button>
                      </Tooltip>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={estadoTramitacion
            .filter((Estado) => {
              const matchesSearch = Estado.nombre
                .toLowerCase()
                .includes(searchTerm.toLowerCase());
              const matchesFilter =
                filterHabilitado === "todos" ||
                (filterHabilitado === "habilitado" && Estado.habilitado === true) ||
                (filterHabilitado === "deshabilitado" && Estado.habilitado === false);
              return matchesSearch && matchesFilter;
            }).length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[10, 25, 50]}
        />
        </>
        ) : (
          renderNoDataMessage()
        )}
      </Grid>
      <NuevoEstadoTramitacionModal
        open={openModal}
        onClose={handleCloseModal}
        onSubmit={handleNuevoEstado}
      />
      <EditarEstadoTramitacionModal
        open={openEditModal}
        onClose={handleCloseEditModal}
        onSubmit={handleEditarEstado}
        estado={estadoSeleccionado}
      />
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default GestorEstadoTramitacion;
